
window.addEventListener("DOMContentLoaded", function() {
  document.documentElement.style.setProperty('--app-height-init', window.innerHeight+'px')
  window.addEventListener('resize', appViewport)
  appViewport()
  // scrollObserver()
})

function appViewport() {
  const scrollbarWidth = window.innerWidth - document.body.clientWidth
  document.documentElement.style.setProperty('--app-height', window.innerHeight+'px')
  // document.documentElement.style.setProperty('--scrollbarWidth', scrollbarWidth+'px')
}

/*
function scrollObserver() {
  Observer.create({
    target: window,
    type: "wheel,scroll",
    onUp: () => monogramDisplay('up'),
    onDown: () => monogramDisplay('down')
  })
  
}

function monogramDisplay(upOrDown) {
  if(upOrDown=='up' || window.pageYOffset==0) document.documentElement.classList.remove('below')
  else document.documentElement.classList.add('below')
}

function goTo(id) {
  
  window.scrollTo({
    top: document.querySelector("[id='"+id+"']").offsetTop - 100,
    left: 0,
    behavior: 'smooth'
  })
}
*/
